import { createSelector } from 'reselect'
import { entitySelector, resultsSelector } from 'containers/Entity/selectors'
import * as R from 'ramda'
import { FILE_TYPE } from 'containers/Project/FileUploadDialog/constants'

import formatSize from 'helpers/FormatSize'
import { getMonthDateYearString } from 'helpers/DateUtil'

const fileEntitySelector = state => entitySelector(state).project_files
  ? entitySelector(state).project_files
  : {}

const fileResultSelector = state => resultsSelector(state).project_files
  ? resultsSelector(state).project_files
  : []

const filesSelector = createSelector(
  fileEntitySelector,
  fileResultSelector,
  (entities, refs) => R.map(
    R.flip(R.prop)(entities)
  )(refs)
)

const formattedFileSelector = createSelector(
  filesSelector,
  R.compose(
    R.map((file) => {
      return file ? ({
        id: file.id,
        fileId: file.fileId,
        thumbnailId: file.thumbnailId,
        revisionId: file.revisionId,
        fileType: file.fileType,
        name: file.name,
        internal: file.internal,
        description: file.description ? file.description : '',
        date: getMonthDateYearString(new Date(file.updatedAt)),
        size: formatSize(file.size),
      }) : {}
    }),
    R.sort(R.descend(R.prop('createdAt')))
  )
)

const filteredFileSelector = createSelector(
  formattedFileSelector,
  (files) =>  R.filter(R.compose(
    R.flip(R.contains)(
      R.map(R.prop('label'))(R.values(FILE_TYPE))
    ),
    R.prop('fileType')
    ))(files)
)

export {
  filesSelector,
  formattedFileSelector,
  fileEntitySelector,
  filteredFileSelector,
}
